(function() {
    'use strict';
    
a3_cabin_reports.controller('AddFlightCtrl', AddFlightCtrl);
    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name AddFlightCtrl
    * @description 
    *   Add a new flight that is not in schedule
    * @ngInject
    */ 
function AddFlightCtrl($scope, UserFactory, FlightFactory, AircraftTypeFactory, $uibModalInstance, $route) {

		$scope.isSecure = UserFactory.isSecure();

		// cancel
		$scope.doCancel =  doCancel;


		// add flight
		$scope.doAdd = doAdd;
		

		// setup datetime pickers
		var now = new Date();
		var minSelectableDate = new Date();
		var maxSelectableDate = new Date();
		minSelectableDate.setDate(now.getDate() - 15);
		maxSelectableDate.setDate(now.getDate() + 2);
		$scope.minSelectableDateStr = minSelectableDate.toString('dd-MM-yyyy');
		$scope.maxSelectableDateStr = maxSelectableDate.toString('dd-MM-yyyy');
		$scope.selectedDate = null;
		$scope.selectedTime = null;

		$scope.hstep = 1;
		$scope.mstep = 1;
		$scope.ismeridian = false;

		$scope.dateFormat = 'dd-MM-yyyy';
		$scope.hourFormat = "HH:mm"

		$scope.datepicker = {
			opened: false
		};


		$scope.openDatepicker = openDatepicker;
        $scope.createFlightFromUIValues = createFlightFromUIValues; 
    
		$scope.processForm = processForm;
    
        // initialize form data
		$scope.formData = {};
    
        // setup aircraft types
		var actypes = AircraftTypeFactory.getAircraftTypesFromStorage();
		if (!(actypes instanceof Array)) actypes = [];
            actypes.push({
			 Code: 'other'
		});
    
		$scope.aircraftTypes = actypes;
	
        /**
         * Open Datepicker
         * @memberof AddFlightCtrl
         */
        function openDatepicker() {
			$scope.datepicker.opened = true;
		}

        /**
         * Close the modal
         * @memberof AddFlightCtrl
         */
        function doCancel() {
			$uibModalInstance.close('cancel');
		} 
    
        /**
         * Add the flight to schedule
         * @memberof AddFlightCtrl
         */
        function doAdd() {
			$scope.processForm();
		}

    
        /**
         * Get the values from ui and create a flight 
         * @memberof AddFlightCtrl
         */
		// 
		function createFlightFromUIValues() {

			// get moment dt from controls
			var flightDate = $scope.formData.flightDateStr;
			var flightSTD = $scope.formData.flightTimeStr;
			// convert them to dates
			flightDate = new Date(flightDate);
			flightSTD = new Date(flightSTD);
			// combine date and time
			flightDate.setHours(flightSTD.getHours(), flightSTD.getMinutes(), 0, 0);
			// flightDate = flightDate.fromUTC();
			// get other flight details
			var flightNumber = $scope.formData.flightNumber;
			var flightDeparture = $scope.formData.flightDeparture;
			var flightDestination = $scope.formData.flightDestination;
			var flightRegNo = $scope.formData.flightRegNo;
			var flightAcType = null;
			if ($scope.formData.flightAcType != null)
				flightAcType = $scope.formData.flightAcType;

			// try to create a local flight
			var newFlight = FlightFactory.createLocalFlight(flightDate, flightNumber, flightDeparture, flightDestination, flightRegNo, flightAcType);

			return newFlight;
		}


        /**
         * Process and validate the form
         * @memberof AddFlightCtrl
         */
		function processForm() {
			// if all valid
			if ($scope.formFlight.$valid) {
				try {
					// try to create a local flight
					var newFlight = $scope.createFlightFromUIValues();

					// save the local flight
					if (newFlight != null) {
						FlightFactory.saveLocalFlight(newFlight);
					}

					if (newFlight == null) {
						bootbox.alert("<h4>Error</h4>Unable to create a flight record.");
					} else {
							(function() {
								$uibModalInstance.close();
								$route.reload();
								})();
					}
				} catch (e) {
					bootbox.alert("<h4>Error</h4>Unable to create a flight record due to unexpected error:\n" + e.message);
				}
			} else {
				bootbox.alert("Please fill in all the required fields.");
			}
		}

		

	}

})();